import { List, EditButton, DeleteButton, useTable } from "@refinedev/antd";
import { Table, Space, Input, Typography, Form, Select, Popover, Button, Tooltip } from "antd";
import { debounce } from "lodash";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FilterOutlined } from "@ant-design/icons";
import { IconDisplay } from "../../components/IconDisplay";

const { Search } = Input;

export function WorkoutPreferencesList() {
    const { Title } = Typography;
    const navigate = useNavigate();
    const [ hoveredRow, setHoveredRow] = useState<string>();

    const handleMouseEnter = (id: string) => {
      setHoveredRow(id); // Set the row id when mouse enters
    };

    const handleMouseLeave = () => {
        setHoveredRow(""); // Reset the hover state when mouse leaves
    };

  const { tableProps, searchFormProps } = useTable({
    syncWithLocation: true,
    queryOptions: {
      keepPreviousData: false,
      cacheTime: 0,
      staleTime: 0
    },
    meta: {
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
      },
    },
    onSearch: (values: any) => {
      return [
        {
          field: "q",
          operator: "contains",
          value: values.q,
        },
        {
          field: "userType",
          operator: "eq",
          value: values.userType ? values.userType.join(',') : undefined,
        },
        // {
        //   field: "ownerID",
        //   operator: "eq",
        //   value: values.ownerID ? values.ownerID : undefined,
        // },
      ];
    },
  });

  // console.log("Preferences:", tableProps.dataSource)

  const handleSearchChange = debounce(() => {
    searchFormProps.form?.submit();
  }, 500);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Description", 
      dataIndex: "description",
      render: (value: string) => (
        <Tooltip 
          title={value || "-"}
          placement="top"
          overlayStyle={{ maxWidth: '385px', maxHeight: '200px', overflow: 'auto' }}
        >
          <span>{value ? `${value.slice(0, 50)}${value.length > 50 ? '...' : ''}` : '-'}</span>
        </Tooltip>
      ),
    },
    // {
    //   title: "Creator",
    //   dataIndex: "ownerName",
    // },
    {
        title: "User Type",
        dataIndex: "userType",
    },
    {
      title: "Icon",
      dataIndex: "iconURL",
      render: (iconURL: string) => <IconDisplay iconURL={iconURL} />
    },
    {
      title: "Actions",
      render: (_: any, record: any) => (
        <Space>
          <EditButton hideText size="small" recordItemId={record.id} />
          <DeleteButton hideText size="small" recordItemId={record.id} />
        </Space>
      ),
    },
  ];


  return (
    <div style={{ padding: "4px", position: "relative" }}>
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 10,
        width: "100%",
        justifyContent: "flex-end",
        alignItems: "flex-start",
      }}>
        <Form {...searchFormProps} onValuesChange={handleSearchChange}>
          <Title level={4}>Filter and Search</Title>
          <div style={{ display: "flex", gap: 10 }}>
            <Popover
              placement="bottomRight" 
              trigger="click"
              content={
                <>
                  <Form.Item name="userType" label="User Type">
                    <Select
                      placeholder="Select user type"
                      allowClear
                      style={{ width: 200 }}
                      mode="multiple"
                    >
                      <Select.Option value="ADMIN">Admin</Select.Option>
                      <Select.Option value="USER">User</Select.Option>
                    </Select>
                  </Form.Item>
                  {/* <Form.Item name="ownerID" label="Owner">
                    <UserSearchSelect 
                      onChange={(value: any) => searchFormProps.form?.setFieldValue('ownerID', value)}
                      userType={searchFormProps.form?.getFieldValue('userType') || []} 
                    />
                  </Form.Item> */}
                </>
              }
            >
              <Button icon={<FilterOutlined />}>Filters</Button>
            </Popover>
            <Form.Item name="q">
              <Input placeholder="Search by name or description" />
            </Form.Item>
          </div>
        </Form>
      </div>
        <List>
          <Table
            {...tableProps}
            columns={columns}
            rowKey="id"
            pagination={{
              ...tableProps.pagination,
              showSizeChanger: true,
              showQuickJumper: true,
              showTotal: (total) => `Total ${total} items`,
            }}
          />
        </List>
      </div>
  );
}